(function ($) {

    $(document).ready(function () {
        var obj = {
            'list-hoover-report': 'edit-mailchimp-lists-mailchimp-21b1edff3c-subscribe',
            'list-defining': 'edit-mailchimp-lists-mailchimp-31433b2ef9-subscribe',
            'list-caravan': 'edit-mailchimp-lists-mailchimp-d790910c21-subscribe',
            'list-hoover-digest': 'edit-mailchimp-lists-mailchimp-db86d9b656-subscribe',
            'list-california': 'edit-mailchimp-lists-mailchimp-7c523ba4de-subscribe',
            'list-event-notification': 'edit-mailchimp-lists-mailchimp-c0f9950213-subscribe',
            'list-strategika': 'edit-mailchimp-lists-mailchimp-ec368bf78b-subscribe',
            'list-monthly-newsletter': 'edit-mailchimp-lists-mailchimp-cf6b4ee2b2-subscribe',
            'list-tune-in': 'edit-mailchimp-lists-mailchimp-c52c8fa9e5-subscribe',
            'list-tower': 'edit-mailchimp-lists-mailchimp-9827b1d4e3-subscribe',
            'list-uncommon-knowledge': 'edit-mailchimp-lists-mailchimp-610ce6eca4-subscribe',
            'list-hoover-monthly-podblast': 'edit-mailchimp-lists-mailchimp-b1eb93251b-subscribe',
            'list-hoover-weekend-review': 'edit-mailchimp-lists-mailchimp-b4742ebbe4-subscribe',
            'list-hoover-monthly-economy': 'edit-mailchimp-lists-mailchimp-21b1edff3c-interest-groups-7093ab25e6-17883c86dc',
            'list-hoover-monthly-education': 'edit-mailchimp-lists-mailchimp-21b1edff3c-interest-groups-7093ab25e6-9e85ca01f0',
            'list-hoover-monthly-security': 'edit-mailchimp-lists-mailchimp-21b1edff3c-interest-groups-7093ab25e6-43084d3ca7',
            'list-hoover-monthly-election': 'edit-mailchimp-lists-mailchimp-21b1edff3c-interest-groups-7093ab25e6-3225ceb986',
            'list-hoover-monthly-briefings': 'edit-mailchimp-lists-mailchimp-21b1edff3c-interest-groups-458d5a14a0-f7849d50cc',
            'list-library-archive': 'edit-mailchimp-lists-mailchimp-198e0bd348-subscribe--2'
        }

        if ($('.newsletter-grid').length > 0) {
            $(".newsletter-grid .cards-wrap .col-four .content-wrap h6").dotdotdot({
                height: 81,
                fallbackToLetter: true,
                watch: true,
            });
            $(".newsletter-grid .cards-wrap .col-four .content-wrap p").dotdotdot({
                height: 105,
                fallbackToLetter: true,
                watch: true,
            });
            $('.newsletter-grid .grid-wrapper .three-col').matchHeight();
            $('.newsletter-grid .cards-wrap .col-four').matchHeight();
            if ($(window).width() < 1399) {
                $('.newsletter-grid .daily-report-wrapper .grid-wrapper .three-col').matchHeight();
            }

            $('.newsletter-grid .form-group input').removeAttr("disabled");

            //code for click to select all checkboxes
            $('.newsletter-grid .form-group input#subscribe').on('click', function () {
                if (this.checked) {
                    $(".newsletter-grid .daily-report-wrapper input").each(function () {
                        this.checked = true;
                        $(this).parents('.daily-report-wrapper').find('.three-col').addClass('show-border');
                    })
                } else {
                    $(".newsletter-grid .daily-report-wrapper input").each(function () {
                        this.checked = false;
                        $(this).parents('.daily-report-wrapper').find('.three-col').removeClass('show-border');
                    })
                }

            });

            ////code for click to select and de-select individual and de-select subscribe all checkbox
            $('.newsletter-grid .three-col .content-wrap > .form-group input').on('click', function () {
                if ($(this).is(":checked")) {
                    var isAllChecked = 0;
                    $(".newsletter-grid .daily-report-wrapper .grid-wrapper input").each(function () {
                        if (!this.checked)
                            isAllChecked = 1;
                    });
                    if (isAllChecked === 0) {
                        $(".newsletter-grid .form-group input#subscribe").prop("checked", true);
                    }
                } else {
                    $(".newsletter-grid .form-group input#subscribe").prop("checked", false);
                }
                if ($(this).parents('.three-col').hasClass('show-border')) {
                    $(this).parents('.three-col').removeClass('show-border');
                }
                else {
                    $(this).parents('.three-col').addClass('show-border');
                }
            });


            $('.newsletter-grid .three-col .content-wrap #list-hoover-monthly-briefings').on('click', function () {
                if ($(this).prop('checked') === false) {
                    // HDR monthly child non selection 
                    let monthlyChilds = $(this).parent().closest('.content-wrap').find('ul input');
                    monthlyChilds.each(function (key, val) {
                        let childID = $(this).attr('id');
                        // let selector = '[id^="' + obj[childID] + '"]';
                        // $(selector).prop('checked', false);
                        let hdrElem = $(`input[data-drupal-selector="${obj[childID]}"]`);
                        if (hdrElem.is(':checked')) {
                            hdrElem.trigger('click');
                        }
                    });

                    $('.newsletter-grid .daily-report-wrapper .grid-wrapper .three-col .content-wrap ul li .form-group input').prop('checked', false);
                    $(".newsletter-grid .daily-report-wrapper .grid-wrapper input").each(function () {
                        if (!this.checked) {
                            $(".newsletter-grid .form-group input#subscribe").prop("checked", false);
                            return false;
                        }
                        else {
                            $(".newsletter-grid .form-group input#subscribe").prop("checked", true);
                        }
                    });

                    // Root HDR checked on monthly child false
                    let HdrChildPos = false;
                    let subItems = $('.sub-hoover-re');
                    subItems.each(function () {
                        let subItemCheck = $(this).prop('checked');
                        if (subItemCheck) {
                            HdrChildPos = true;
                            return false;
                        }
                    });
                    if (!HdrChildPos) {
                        $('#list-hoover-report').prop('checked', false);
                        let hdrElem = $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`);
                        if (hdrElem.is(':checked')) {
                            hdrElem.trigger('click');
                        }
                    }
                }
                else {
                    // HDR monthly child selection 
                    $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`).trigger('click');
                    let monthlyChilds = $(this).parent().closest('.content-wrap').find('ul input');
                    monthlyChilds.each(function (key, val) {
                        let childID = $(this).attr('id');
                        // let selector = '[id^="' + obj[childID] + '"]';
                        // $(selector).trigger('click');
                        $(`input[data-drupal-selector="${obj[childID]}"]`).trigger('click');
                    });

                    $('.newsletter-grid .daily-report-wrapper .grid-wrapper .three-col .content-wrap ul li .form-group input').prop('checked', true);
                    var len_check = $(".newsletter-grid .daily-report-wrapper .grid-wrapper input:checked").length;
                    var tot_len = $(".newsletter-grid .daily-report-wrapper .grid-wrapper input").length;
                    if ($('.newsletter-grid .three-col .content-wrap #list-hoover-monthly-briefings').is(':checked')) {
                        if (tot_len === len_check) {
                            $(".newsletter-grid .form-group input#subscribe").prop("checked", true);
                        }
                        else {
                            $(".newsletter-grid .form-group input#subscribe").prop("checked", false);
                        }
                    }
                    else {
                        $(".newsletter-grid .form-group input#subscribe").prop("checked", false);
                    }

                    // Root HDR checked on monthly child true
                    let subItems = $('.sub-hoover-re');
                    subItems.each(function () {
                        let subItemCheck = $(this).prop('checked');
                        if (subItemCheck) {
                            $('#list-hoover-report').prop('checked', true);
                            // $('[id^="' + obj['list-hoover-report'] + '"]').trigger('click');
                            // $('[id^="' + obj['list-hoover-report'] + '"]').prop('checked', true);
                            let hdrElem = $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`);
                            if (!hdrElem.is(':checked')) {
                                hdrElem.trigger('click');
                            }
                            return false;
                        }
                    });
                }
            });

            $('.newsletter-grid .three-col .content-wrap #list-hoover-weekend-review').on('click', function () {
                if ($(this).prop('checked') === true) {
                    // Root HDR checked on monthly child true
                    // let subItems = $('.sub-hoover-re');
                    // subItems.each(function() {  
                    //     let subItemCheck = $(this).prop('checked');
                    //     if (subItemCheck) {
                    //         $('#list-hoover-report').prop('checked', true);
                    //         $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`).trigger('click');
                    //         return false;
                    //     }
                    // });
                    let hdrElem = $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`);
                    $('#list-hoover-report').prop('checked', true);
                    if (!hdrElem.is(':checked')) {
                        hdrElem.trigger('click');
                    }
                } else {
                    // Root HDR checked on monthly child false
                    let HdrChildPos = false;
                    let subItems = $('.sub-hoover-re');
                    subItems.each(function () {
                        let subItemCheck = $(this).prop('checked');
                        if (subItemCheck) {
                            HdrChildPos = true;
                            return false;
                        }
                    });
                    if (!HdrChildPos) {
                        $('#list-hoover-report').prop('checked', false);
                        let hdrElem = $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`);
                        if (hdrElem.is(':checked')) {
                            hdrElem.trigger('click');
                        }
                    }
                }
            });

            $('.newsletter-grid .three-col .content-wrap .monthly-sub-list').on('click', function () {
                if ($(this).prop('checked') === true) {
                    // Root HDR checked on monthly child true
                    let subItems = $('.sub-hoover-re');
                    subItems.each(function () {
                        let subItemCheck = $(this).prop('checked');
                        if (subItemCheck) {
                            $('#list-hoover-report').prop('checked', true);
                            let hdrElem = $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`);
                            if (!hdrElem.is(':checked')) {
                                hdrElem.trigger('click');
                            }
                            return false;
                        }
                    });
                } else {
                    // Root HDR checked on monthly child false
                    let HdrChildPos = false;
                    let subItems = $('.sub-hoover-re');
                    subItems.each(function () {
                        let subItemCheck = $(this).prop('checked');
                        if (subItemCheck) {
                            HdrChildPos = true;
                            return false;
                        }
                    });
                    if (!HdrChildPos) {
                        $('#list-hoover-report').prop('checked', false);
                        let hdrElem = $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`);
                        if (hdrElem.is(':checked')) {
                            hdrElem.trigger('click');
                        }
                    }
                }
            });

            $('.newsletter-grid .cards-wrap .col-four input').on('click', function () {
                if (this.checked) {
                    $(this).parents('.col-four').addClass('show-border');
                }
                else {
                    $(this).parents('.col-four').removeClass('show-border');
                }
            });

            // ── Newsletter Cookie Banner ──────────────────────────────────
            var $banner = $('#newsletter-cookie-banner');
            var $countEl = $('#ncb-selected-count');
            var $pluralEl = $('#ncb-plural');
            var bannerDismissed = false;

            // IDs that are programmatically toggled as side-effects and should not be counted separately.
            var DEPENDENT_IDS = new Set([]);

            function updateBanner() {
                // Use a Set to count unique newsletter IDs, preventing double-counting.
                // Exclude dependent IDs that are auto-toggled by briefingHandler (not standalone cards).
                var selectedIds = new Set();
                $('.newsletter-grid .hubspot_list:checked').each(function () {
                    if (this.id && !DEPENDENT_IDS.has(this.id)) {
                        selectedIds.add(this.id);
                    }
                });
                var count = selectedIds.size;

                $countEl.text(count);
                $pluralEl.text(count === 1 ? '' : 's');

                if (count > 0 && !bannerDismissed) {
                    $banner.addClass('ncb-visible');
                } else if (count === 0) {
                    $banner.removeClass('ncb-visible');
                    bannerDismissed = false; // reset dismiss if all unchecked
                }
            }

            // Listen for any checkbox click inside the newsletter grid (covers .hubspot_list checkboxes)
            // Use 'click' (not 'change') because the inputs are display:none and click fires more reliably,
            // and use a small delay so the checked state is settled before reading it.
            $(document).on('click', '.newsletter-grid .form-group input', function () {
                var count = $('.newsletter-grid .hubspot_list:checked').length;
                if (count > 0) {
                    bannerDismissed = false;
                }
                setTimeout(updateBanner, 20);
            });

            // Subscribe All: sets checked programmatically, so run updateBanner after a delay
            $('#subscribe_all').on('click', function () {
                bannerDismissed = false;
                setTimeout(updateBanner, 100); // allow all checkboxes to be set
            });

            // Close button
            $('#ncb-close-btn').on('click', function () {
                bannerDismissed = true;
                $banner.removeClass('ncb-visible');
            });

            // ── Step 1: Sign Up button — validates email, reveals Step 2 ──
            $('#ncb-signup-btn').on('click', function () {
                var email = $('#ncb-email').val().trim();
                var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(email)) {
                    $('#ncb-email').addClass('ncb-error').focus();
                    return;
                }
                $('#ncb-email').removeClass('ncb-error');

                // Show Step 2 with the email address displayed
                $('#ncb-step2 .ncb-step2-email-display').text(email);
                $('#ncb-step1').hide();
                $('#ncb-step2').show();
                $('#ncb-firstname').focus();
            });

            // ── Step 2: Back button — return to Step 1 ──
            $('#ncb-back-btn').on('click', function () {
                $('#ncb-step2').hide();
                $('#ncb-step1').show();
                $('#ncb-error-msg').hide().text('');
            });

            // ── Step 2: Create Account — redirect to /myhoover/create-account ──
            $('#ncb-create-btn').on('click', function () {
                var email = $('#ncb-email').val().trim();
                var firstname = $('#ncb-firstname').val().trim();
                var lastname = $('#ncb-lastname').val().trim();
                var $errMsg = $('#ncb-error-msg');

                if (!firstname) {
                    $errMsg.text('First name is required.').show();
                    $('#ncb-firstname').focus();
                    return;
                }

                $errMsg.hide().text('');

                // Store name so the create-account page can pre-fill fields
                try {
                    sessionStorage.setItem('ncb-signup-email', email);
                    sessionStorage.setItem('ncb-signup-firstname', firstname);
                    sessionStorage.setItem('ncb-signup-lastname', lastname);
                } catch (e) { /* sessionStorage may be blocked */ }

                // Redirect to sign-up page with email in URL
                window.location.href = '/myhoover/create-account?email=' + encodeURIComponent(email);
            });

            // Remove error state on email input
            $('#ncb-email').on('input', function () {
                $(this).removeClass('ncb-error');
            });

            $('.newsletter-grid .daily-report .hoover-report #list-hoover-report').on('click', function () {
                var len_check = $(".newsletter-grid .daily-report-wrapper .grid-wrapper input:checked").length;
                var tot_len = $(".newsletter-grid .daily-report-wrapper .grid-wrapper input").length;
                if ($('.newsletter-grid .daily-report .hoover-report #list-hoover-report').is(':checked')) {
                    if (tot_len === len_check) {
                        $(".newsletter-grid .form-group input#subscribe").prop("checked", true);
                    }
                    else {
                        $(".newsletter-grid .form-group input#subscribe").prop("checked", false);
                    }
                }
                else {
                    $(".newsletter-grid .form-group input#subscribe").prop("checked", false);
                    $(this).closest('.daily-report-wrapper').find('.sub-hoover-re').closest('.three-col').removeClass('show-border');
                }
            });
        }
    });

})(jQuery);